import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { BaseService } from '../../../shared/services/base.service';
import { IDashboardFilter, IDashboard, IDashboardShow } from '../../dashboard/models/dashboard';

@Injectable({
  providedIn: 'root'
})
export class DashboardsService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}CompanyDashboard`;

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  listarMyDashboardsByFilter(filtros: IDashboardFilter): Observable<ResponseDefault<IDashboardShow[]>> {
    return this.http.post<ResponseDefault<IDashboardShow[]>>(`${this.apiUrl}/ListByFilterAsync`, filtros);
  }

  listarTodosMyDashboards(): Observable<ResponseDefault<IDashboardShow[]>> {
    return this.http.get<ResponseDefault<IDashboardShow[]>>(`${this.apiUrl}/ListActive`);
  }

  adicionarMyDashboard(dashboard: IDashboard): Observable<ResponseDefault<string>> {
    return this.http.post<ResponseDefault<string>>(`${this.apiUrl}`, dashboard);
  }

  editarMyDashboard(dashboard: IDashboard): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}`, dashboard);
  }

  inativarDashboard(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/SetInactiveAsync/${id}`, {});
  }

  ativarDashboard(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/SetActiveAsync/${id}`, {});
  }
}
